import { useEffect, useState } from 'react';

import ActivityUnderProject from '../features/ics/projectics/ActivityUnderProject';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useFetchData from '../hooks/useFetchData';
import { getActivitiesInProject } from '../apis/impact-report/report';
import BackButton from '../assets/icons/BackButton';
import Heading from '../ui/Heading';
import Loader from '../ui/Loader';
import NoDataAvailable from '../ui/NoDataAvailable';

function ActivitiesProjectFullScreen() {
    const navigate = useNavigate();
      const {projectId} = useParams()
    const [searchParams] = useSearchParams();
    const projectTitle = searchParams.get('projectTitle');
    
    const { loading, response, error } = useFetchData(getActivitiesInProject,[projectId],[projectId]);
    return (
        <div className="py-9 px-16" >
            <div className="w-[50%] mb-6">
                <div className="flex items-center">
                    <BackButton onClick={() => navigate(-1)} />
                    <Heading type={'pageHeading'} className={'text-textPrimary ml-3'}>
                        {projectTitle}
                    </Heading>
                </div>
              
            </div>
            <div className={`grid grid-cols-2 gap-6`}>
                {loading ? (
                    <div className="h-40 col-span-2 bg-grayBgNormal flex items-center justify-center">
                        <Loader />
                    </div>
                ) : (
                    <>
                        {response?.length > 0 ? (
                            response?.map((activity) => {
                                return (
                                    <ActivityUnderProject isFull={true} key={activity?._id + Math.random()} activity={activity}/>
                                );
                            })
                        ) : (
                            <div className="h-auto min-h-40 col-span-2 bg-grayBgNormal flex items-center justify-center">
                                <NoDataAvailable marginTop="mt-8" imgClassName="w-36" className="mb-8" />
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default ActivitiesProjectFullScreen;
